import { CreditSimulationOriginEnum, OnlineContractingStateEnum } from 'v3/data/store/onlineContracting/enums';

type MappingValue = {
  name: string;
  title: string;
};

export const CHANNEL_LABEL_MAP: Record<CreditSimulationOriginEnum, string> = {
  [CreditSimulationOriginEnum.InApp]: 'App DIMO',
  [CreditSimulationOriginEnum.LOM]: 'LOM',
};

export const getChannelLabel = (origin: CreditSimulationOriginEnum): string => {
  return CHANNEL_LABEL_MAP[origin] ?? '-';
};

export enum ContractingOriginSlugEnum {
  InApp = 'in-app',
  LOM = 'lom',
}

const ORIGIN_SLUG_MAP: Record<CreditSimulationOriginEnum, ContractingOriginSlugEnum> = {
  [CreditSimulationOriginEnum.InApp]: ContractingOriginSlugEnum.InApp,
  [CreditSimulationOriginEnum.LOM]: ContractingOriginSlugEnum.LOM,
};

export const getOriginSlug = (origin?: string): ContractingOriginSlugEnum | undefined => {
  return ORIGIN_SLUG_MAP[origin as CreditSimulationOriginEnum];
};

export const getOriginFromSlug = (slug?: string): CreditSimulationOriginEnum | undefined => {
  return (Object.keys(ORIGIN_SLUG_MAP) as CreditSimulationOriginEnum[]).find(
    (origin) => ORIGIN_SLUG_MAP[origin] === slug,
  );
};

type OnlineContractingStateMappingType = Record<OnlineContractingStateEnum, MappingValue>;

export const OnlineContractingStateMapping: OnlineContractingStateMappingType = {
  CONTRATACAO_INICIADA: {
    name: 'ContratacaoIniciada',
    title: 'Contratação Iniciada',
  },
  PROCESSANDO_ANALISE_CREDITO: {
    name: 'ProcessandoAnaliseCredito',
    title: 'Processando Análise de Crédito',
  },
  ANALISE_CREDITO_REPROVADA: {
    name: 'AnaliseCreditoReprovada',
    title: 'Análise de Crédito Reprovada',
  },
  AGUARDANDO_GERACAO_PROPOSTA: {
    name: 'AguardandoGeracaoProposta',
    title: 'Aguardando Geração de Proposta',
  },
  AGUARDANDO_DOCUMENTOS: {
    name: 'AguardandoDocumentos',
    title: 'Aguardando Documentos',
  },
  AGUARDANDO_SELFIE: {
    name: 'AguardandoSelfie',
    title: 'Aguardando Selfie',
  },
  CAF_REPROVADA: {
    name: 'CafReprovada',
    title: 'CAF Reprovada',
  },
  AGUARDANDO_DADOS_CADASTRAIS: {
    name: 'AguardandoDadosCadastrais',
    title: 'Aguardando Dados Cadastrais',
  },
  CONTRATACAO_FINALIZADA: {
    name: 'ContratacaoFinalizada',
    title: 'Contratação Finalizada',
  },
  CPF_BLOQUEADO: {
    name: 'CpfBloqueado',
    title: 'CPF Bloqueado',
  },
  AGUARDANDO_ACEITE_PROPOSTA: {
    name: 'AguardandoAceiteProposta',
    title: 'Aguardando Aceites da Proposta',
  },
  AGUARDANDO_ACEITES_TERMOS: {
    name: 'AguardandoAceiteTermos',
    title: 'Aguardando Aceite dos Termos',
  },
  PROCESSANDO_ANTIFRAUDE: {
    name: 'ProcessandoAntifraude',
    title: 'Análise de documento em andamento',
  },
  AGUARDANDO_EFETIVACAO_CONTRATO: {
    name: 'AguardandoEfetivacaoContrato',
    title: 'Aguardando Efetivação do Contrato',
  },
  CONTRATACAO_NEGADA: {
    name: 'ContratacaoNegada',
    title: 'Contratação Negada',
  },
  CHAVE_EXPIRADA: {
    name: 'ChaveExpirada',
    title: 'Chave Expirada',
  },
  CONTRATACAO_CANCELADA: {
    name: 'ContratacaoCancelada',
    title: 'Contratação Cancelada',
  },
  AGUARDANDO_PAGAMENTO_ENTRADA: {
    name: 'AguardandoPagamentoEntrada',
    title: 'Aguardando Pagamento da Entrada',
  },
  AGUARDANDO_FATURAMENTO: {
    name: 'AguardandoFaturamento',
    title: 'Aguardando Faturamento',
  },
  PROCESSANDO_FATURAMENTO: {
    name: 'ProcessandoFaturamento',
    title: 'Processando Faturamento',
  },
  PROCESSANDO_CANCELAMENTO: {
    name: 'ProcessandoCancelamento',
    title: 'Processando Cancelamento',
  },
};
